import React, { useEffect, useState } from 'react'
import { TabPanel, Tabs } from '@paypalcorp/pp-react'

import { useMessage } from '../../hooks/useMessage'
import useTracking from '../../hooks/useTracking'
import { TAB_SWITCHER_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

import './tab-switcher.less'

function TabSwitcher(props) {
  const { name, tabsInfo, renderTabContent, articleId } = props
  const [tabsProps, setTabsProps] = useState([])
  const [selectedTabIdx, setSelectedTabIdx] = useState(0)
  const { getMessage } = useMessage()
  const { trackClick } = useTracking()

  useEffect(() => {
    if (Array.isArray(tabsInfo)) {
      const formattedTabsProps = tabsInfo.map((tab) => ({
        id: tab.id,
        panelId: `p-${tab.id}`,
        label: tab.label,
      }))
      setTabsProps(formattedTabsProps)
    }
  }, [tabsInfo, getMessage])

  const onTabClickHandler = (_, tabIndex) => {
    if (tabIndex === selectedTabIdx) {
      return
    }
    const { componentName, exp } = tabsInfo[tabIndex].tabProps
    trackClick({
      name: componentNames.TAB_SWITCHER,
      type: fptiTypes.ON_CLICK,
      hpid: articleId,
      help_doc_id: articleId,
      exp,
      link: `${componentNames.TAB_SWITCHER}|${articleId}|${componentName}`,
    })
    setSelectedTabIdx(tabIndex)
  }

  const renderTabs = () => {
    if (Array.isArray(tabsProps) && tabsProps.length) {
      return (
        <Tabs
          name={name}
          selectedTabIdx={selectedTabIdx}
          onClick={onTabClickHandler}
          tabs={tabsProps}
          className="hc_tab_switcher_tabs"
          tabClassName="hc_tab_switcher_tabs__btn"
        >
          {tabsInfo.map((tab) => (
            <TabPanel
              className="hc_tab_switcher_tab__content"
              key={tab.id}
              id={tab.id}
              tabId={`p-${tab.id}`}
            >
              {renderTabContent(tab.tabProps)}
            </TabPanel>
          ))}
        </Tabs>
      )
    }
    return null
  }

  return renderTabs()
}

TabSwitcher.propTypes = TAB_SWITCHER_DATA

export default TabSwitcher
